import React from 'react';
import * as S from './BookHotels.styles';

const BookHotels = () => {
  return (
    <S.Wrapper>
      <S.Banner
        src="https://mailmktg.makemytrip.com/images/myPartner-guest-friendly-hotels-tb-290224.jpg"
        alt=""
      />
      <S.CalloutDiv>
        <span className="callout">Abb rakho apne customers ka khayaal</span>
        <br />
        <span className="callout">with the best guest-friendly hotel options in Pattaya!</span>
        <span className="boldText">Don’t miss out.</span>
      </S.CalloutDiv>
      <S.CtaContainer>
        <p>Booking Dates: 21st April – 8th May 2024</p>
        <S.BookCta
          onClick={() => {
            window.open('https://mypartner.makemytrip.com/landing/flights', '_self');
          }}
        >
          Book Now
        </S.BookCta>
        <br />
        <span>*T&C Apply</span>
      </S.CtaContainer>
    </S.Wrapper>
  );
};

export default BookHotels;
